import React, { forwardRef, useEffect, useImperativeHandle, useMemo, useRef, useState } from "react";
import styles from "./multiSelectBox.module.scss";
import Select, { components } from "react-select";
import "./multiSelect.css";

const CheckboxOption = (props) => {
  const { isSelected, label, showCheckbox } = props;
  return (
    <components.Option {...props}>
      {showCheckbox && <input type="checkbox" checked={isSelected} readOnly style={{ marginRight: 8 }} />}
      {label}
    </components.Option>
  );
};

export const MultiSelect = forwardRef(
  (
    {
      classes,
      id = "",
      label,
      name = "",
      placeholder = "Select",
      optionValue = [],
      defaultValue = [],
      disabled = false,
      validator,
      required,
      errors,
      onSelect,
      onRemove,
      showCheckbox,
      displayValue,
      groupBy,
      customErrors,
      customErrorsMsg,
      labelSubText,
      errorBorder,
      closeOnSelect = false,
    },
    ref
  ) => {
    const selectRef = useRef(null);
    const stateRef = useRef({
      selectedValues: [],
    });
    const mappedOptions = useMemo(
      () =>
        optionValue?.map((opt) => ({
          value: opt.key || opt.id || "",
          label: opt[displayValue] || opt.label || opt.name || opt.key,
          raw: opt,
        })),
      [optionValue, displayValue]
    );

    const initialSelected = useMemo(
      () => mappedOptions.filter((opt) => defaultValue?.some((d) => String(typeof d === "object" ? d.key : d) === String(opt.value))),
      [mappedOptions, defaultValue]
    );

    const [selectedValue, setSelectedValue] = useState(initialSelected);

    const api = useMemo(() => ({
      resetSelectedValues: () => {
        setSelectedValue([]);
        stateRef.current.selectedValues = [];
        onRemove?.([]);
      },
      state: stateRef.current,
      selectRef: selectRef?.current,
    }), [onRemove])

    useImperativeHandle(ref, () => api, [api]);

    useEffect(() => {
      if (validator) {
        validator(api);
      }
    }, [api, validator]);

    const handleChange = (newValue, actionMeta) => {
      const values = newValue.map((v) => v.raw);
      setSelectedValue(newValue);

      stateRef.current.selectedValues = values;

      if (actionMeta.action === "select-option") {
        const selectedItem = actionMeta.option?.raw;
        onSelect(values, selectedItem);
      } else if (actionMeta.action === "remove-value" || actionMeta.action === "pop-value" || actionMeta.action === "clear") {
        const removedItem = actionMeta.option?.raw;
        onRemove?.(values, removedItem);
      }
    };
    return (
      <div className={classes?.column || ""}>
        {label && (
          <label htmlFor={id} className={classes?.labelClassName || ""}>
            {label} {required && <span className={styles.astrick}>&#42;</span>}
            {labelSubText && <div className={styles.bir_subline}>{labelSubText}</div>}
          </label>
        )}

        <div className={`${classes?.inputColumn || ""} ${errorBorder ? styles.error_border_color : ""}`}>
          <Select
            inputId={id}
            name={name}
            ref={selectRef}
            isDisabled={disabled}
            isMulti
            options={mappedOptions}
            value={selectedValue}
            onChange={handleChange}
            placeholder={placeholder}
            closeMenuOnSelect={closeOnSelect}
            hideSelectedOptions={false}
            components={{
              Option: (props) => <CheckboxOption {...props} showCheckbox={showCheckbox} />,
              IndicatorSeparator: () => null,
            }}
            styles={{
              option: (provided, state) => ({
                ...provided,
                backgroundColor: state.isSelected ? "transparent" : state.isFocused ? "#f5f5f5" : "transparent",
                color: "inherit",
              }),
              menuPortal: (base) => ({ ...base, zIndex: 9999 }),
            }}
            menuPortalTarget={document.body}
          />
          {customErrors && <span className={`${styles.error_message}`}>{customErrors ? customErrorsMsg : ""}</span>}
        </div>

        {errors && (
          <span className={`col-6 ${id === "exudateType" ? "offset-5" : "offset-6"} px-1 ${styles.error_message}`}>
            {errors[name]?.message || ""}
          </span>
        )}
        {errorBorder && <span className={`col-6 offset-5 p-0 pt-1 ${styles.error_message}`}>Product Manager is required</span>}
      </div>
    );
  }
);
